import type { MapStateToPropsFactory } from 'react-redux';
import { connect } from 'react-redux';
import type { SidePanelStatus } from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm';
import { fromSecondaryMarket } from 'state/selectors';
import type { AppState } from 'state/state.model';

type OwnProps = Readonly<{
  tabId: string;
}>;

type StateProps = Readonly<{
  status: SidePanelStatus;
}>;

export type SidePanelProps = OwnProps & StateProps;

const mapStateToProps: MapStateToPropsFactory<StateProps, OwnProps, AppState> = () => {
  const getFormStatus = fromSecondaryMarket.makeGetSecondaryMarketRtFormStatus();
  return (state, { tabId }) => {
    return {
      status: getFormStatus(state, tabId),
    };
  };
};

export const connectSidePanel = connect(mapStateToProps);
